import Model from 'src/storage/list';

export class ClinicProfileManagersModel extends Model {
  id = 'ClinicProfileManagersModel';
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;
  defaultState = () => ({
    current: 'recent',
    clinic: null,
    activeTab: 'medici',
    specialist: null
  });
  apiConfig = {
    refresh: {
      url: 'clinic/manager/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'ClinicProfileManagersModel_refresh'
    },
    list: {
      url: 'clinic/manager/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/manager/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams(loadMore) {
    if (!this.state.clinic?.id) return null;
    const req = {
      clinicId: this.state.clinic?.id,
      skip: 0,
      limit: this.listLimit,
      orderByCustomerSupport: this.state.hospitalId || '*'
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  selectHospitalId(hospitalId) {
    this.handleChangeSearch('');
    this.setStateSilent({ hospitalId });
    return this.refresh();
  }
}

const model = new ClinicProfileManagersModel();
export default model;
